<template>
  <VcModal v-if="pdfUrl" :title="resolvedTitle" is-mobile-fullscreen>
    <div v-if="blobUrl" style="height: 70vh">
      <iframe :src="blobUrl" style="width: 100%; height: 100%; border: none" />
    </div>
    <div v-else-if="fetchError" class="p-4 text-danger">{{ fetchError }}</div>
    <div v-else class="flex items-center justify-center" style="height: 70vh">
      <VcLoader />
    </div>
  </VcModal>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const props = withDefaults(defineProps<IProps>(), {
  pdfUrl: () => "",
  isOpen: () => true,
  title: () => "",
});

interface IProps {
  pdfUrl?: string;
  isOpen?: boolean;
  title?: string;
}

const { t } = useI18n();
const resolvedTitle = computed(() => props.title || t("common.titles.user_agreement"));

const blobUrl = ref<string>("");
const fetchError = ref<string>("");

onMounted(async () => {
  if (!props.pdfUrl) return;
  try {
    const response = await fetch(props.pdfUrl);
    if (!response.ok) throw new Error(`${response.status}`);
    const blob = await response.blob();
    blobUrl.value = URL.createObjectURL(blob);
  } catch {
    fetchError.value = t("common.messages.pdf_load_error");
  }
});

onUnmounted(() => {
  if (blobUrl.value) URL.revokeObjectURL(blobUrl.value);
});
</script>
